/**
 * 并发数不够的消息
 */
import { Button } from 'antd';
import CheckedIcon from '/public/checked.svg';
import React, { useState } from 'react';
import { useI18n } from '@/hooks/use-i18n';

interface NoConcurrentMsgProps {
  onContinue: () => Promise<void>;
}

const NoConcurrentMsg: React.FC<NoConcurrentMsgProps> = ({ onContinue }) => {
  const { t } = useI18n('thread');
  const [isLoading, setIsLoading] = useState(false);

  const handleContinue = async () => {
    setIsLoading(true);
    try {
      await onContinue();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-between bg-[#7171EE33] rounded-[8px] h-10 px-3">
      <span className="flex items-center gap-2">
        <CheckedIcon className="w-4 h-4" />
        <span className="text-primary font-semibold text-[14px]">
          {t('message.noConcurrent.completed')}
        </span>
      </span>
      <Button
        size="small"
        shape="round"
        loading={isLoading}
        onClick={handleContinue}
        className="!px-[5px] !text-primary !text-[13px] !border-primary"
      >
        {t('message.noConcurrent.continue')}
      </Button>
    </div>
  );
};

export default NoConcurrentMsg;
